import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import CategoriesSection from "../components/CategoriesSection";
import WhyChooseUs from "../components/WhyChooseUs";
import ManufacturingProcess from "../components/ManufacturingProcess";
import CatalogSection from "../components/CatalogSection";
import StatsSection from "../components/StatsSection";
import Testimonials from "../components/Testimonials";
import ProductHighlights from "../components/ProductHighlights";
import CTASection from "../components/CTASection";
import MapSection from "../components/MapSection";
import HeroSlider from "../components/HeroSlider";

export default function Home() {
  const navigate = useNavigate();
  return (
    <>
      {/* HERO SLIDER */}
      <HeroSlider />
      {/* About Section  */}
      <section className="about-section">
        <div className="container">
          <div className="row align-items-center">

            {/* LEFT CONTENT */}
            <div className="col-lg-6 mb-4 mb-lg-0">
              <div className="about-content">
                <h6 className="about-subtitle">ABOUT Goodweel CROP CARE</h6>
                <h2>
                  Trusted Partner in <span>Indian Agriculture</span>
                </h2>
                <p>
                  Goodweel Crop Care is a trusted agrochemical manufacturing
                  company with over <strong>10+ years</strong> of experience,
                  dedicated to strengthening Indian agriculture through
                  modern technology, scientific research, and real field expertise.
                </p>
                <p>
                  We work closely with farmers to deliver reliable, effective,
                  and sustainable crop protection solutions that improve crop
                  health, productivity, and long-term soil balance.
                </p>

                <div className="about-highlights">
                  <div>✔ ISO 9001 : 2015 Certified</div>
                  <div>✔ 250+ Quality Agricultural Products</div>
                  <div>✔ Farmer-First & Eco-Friendly Approach</div>
                </div>

                <button className="about-btn" onClick={() => navigate("/about")}>Read More About Us</button>
              </div>
            </div>

            {/* RIGHT IMAGE */}
            <div className="col-lg-6">
              <div className="about-image">
                <img
                  src="/images/img/2.png"
                  alt="Goodweel Crop Care Agriculture"
                  className="img-fluid"
                />
              </div>
            </div>

          </div>
        </div>
      </section>
      <CategoriesSection />
      <WhyChooseUs />
      <section className="eco-section">
        <div className="container">
          <div className="row">

            {/* LEFT STICKY IMAGE */}
            <div className="col-lg-6">
              <div className="eco-image sticky-image">
                <img
                  src="/images/img/9.jpg"
                  alt="Eco Friendly Agriculture"
                  className="img-fluid"
                />
              </div>
            </div>

            {/* RIGHT SCROLL CONTENT */}
            <div className="col-lg-6">
              <div className="eco-content scroll-content">
                <h6 className="section-subtitle">ECO-FRIENDLY COMMITMENT</h6>
                <h2>
                  Growing Crops with <span>Care for Nature</span>
                </h2>

                <p>
                  Goodweel Crop Care is committed to eco-friendly and
                  bio-organic agricultural solutions that reduce dependency
                  on harmful chemicals while maintaining productivity.
                </p>

                <p>
                  Our solutions help farmers improve soil health, reduce
                  environmental impact, and achieve sustainable yields
                  without compromising nature.
                </p>

                <div className="eco-features">
                  <div className="eco-card">
                    <h5>🌱 Soil Health Protection</h5>
                    <p>Maintains fertility and microbial balance.</p>
                  </div>

                  <div className="eco-card">
                    <h5>💧 Water-Safe Solutions</h5>
                    <p>Minimizes contamination and protects ecosystems.</p>
                  </div>

                  <div className="eco-card">
                    <h5>♻️ Reduced Chemical Use</h5>
                    <p>Lower costs with eco-responsible farming.</p>
                  </div>

                  <div className="eco-card">
                    <h5>🌾 Sustainable Growth</h5>
                    <p>Better yield with long-term sustainability.</p>
                  </div>
                </div>

                <button className="eco-btn"
                  onClick={() => navigate("/products")}
                >
                  Our Green Practices
                </button>
              </div>
            </div>

          </div>
        </div>
      </section>
      <ProductHighlights />
      <ManufacturingProcess />
      <CatalogSection />
      <StatsSection />
      <Testimonials />
      <MapSection />
      <CTASection />
    </>
  );
}